




































































































import $ from "jquery";
import { Vue, Component, Watch, Ref } from "vue-property-decorator";
import algoliasearch, { SearchClient } from "algoliasearch";
import { nextTick } from 'vue/types/umd';
import ProductLeaf from "./component/ProductLeaf.vue";
import { settings, currency } from "@/loader";

@Component({
	components: {
		ProductLeaf,
	}
})
export default class SearchBar extends Vue {
	public client!: SearchClient;
	public inInput: boolean = false;
	public inDropdown: boolean = false;
	public initSearchDone: boolean = false;

	@Ref()
	public searchBox!: Vue;

	public get productsIndexName(): string {
		return settings.algolia_products_index;
	}

	public get categoriesIndexName(): string {
		return settings.algolia_categories_index;
	}

	public get url() {
		return item => `https://www.laboandco.com/${item.url_key}`;
	}

	public get test() {
		return item => {
			console.log(item);
			return "";
		};
	}

	public created() {
		this.client = algoliasearch(settings.algolia_aplication_id, settings.algolia_search_api_key);
	}

	public initSearch() {
		if (!this.initSearchDone) {
			$(".ais-SearchBox-form").attr("action", "https://www.laboandco.com/search").attr("method", "GET");
			$(".ais-SearchBox-input").attr("name", "query").on("keydown", function (e: KeyboardEvent) {
				if (e.keyCode === 13) {
					$(".ais-SearchBox-form").submit();
				}
			});
			this.initSearchDone = true;
		}
	}

	public scrollBack() {
		this.$nextTick().then(() => {
			this.searchBox.$el.scrollIntoView(false);
		});
	}

	@Watch("inDropdown")
	public inDropdownChanged(newValue?: boolean, oldValue?: boolean) {
		if (!newValue && !this.inInput && newValue !== oldValue) {
			this.scrollBack();
		}
	}

	@Watch("inInput")
	public inInputChanged(newValue?: boolean, oldValue?: boolean) {
		if (!newValue && !this.inDropDown && newValue !== oldValue) {
			this.scrollBack();
		}
	}
}
